<div class="manager-panel">
    <p class="fw-bold">
        <i class="fa-solid fa-lock pe-2"></i>{{'timeline.manager_panel' | translate}}
    </p>

    <!-- @if(!reviewed){ -->
        <!-- <div class="pt-2 fst-italic">
            {{'timeline.manager_panel.not_reviewed' | translate}}
        </div> -->
    <!-- }@else { -->
        <div [ngClass]="managerPanel.assignees.length > 0 ? 'py-2': 'pt-2 fst-italic'">
            @if(managerPanel.assignees.length > 0){
                <p>{{'timeline.manager_panel.assignees' | translate}}</p>
                <div class="task-assignee">
                        @for(assignee of managerPanel.assignees; track assignee.id){
                            @if($index < 3){
                                <username-icon context="thread"
                                            [userInfos]="userInfos(assignee)"></username-icon>
                            }
                    }
                    @if(managerPanel.assignees.length > 3){
                        <small class="ps-1 text-secondary"
                            [matTooltip]="getTooltipAssigneesContent(managerPanel.assignees)">+{{managerPanel.assignees.length - 3}}</small>
                    }
                </div> 
                }@else {
                {{'timeline.manager_panel.not_assigned' | translate}}
            } 
        </div>
    
        <div [ngClass]="managerPanel.labels.length > 0 ? 'py-2': 'pt-2 fst-italic'">
            @if(managerPanel.labels.length > 0){
                <p>{{'timeline.manager_panel.labels' | translate}}</p>
                <div class="task-labels">
                        @for(label of managerPanel.labels; track label.id){ 
                            <span class="badge text-bg-light me-1"> <i class="fa-solid fa-circle pe-1" [ngStyle]="{'color': label.color}"></i>{{label.name}}</span> 
                        }  
                </div>
            }@else {
                {{'timeline.manager_panel.no_label' | translate}}
            }
        </div>
    <!-- } -->

    
        
    <div class="pt-3">
        <a class="btn btn-sm btn-primary" href="{{managerPanel.backlogLink}}">
            {{'timeline.manager_panel.view_in_backlog' | translate}}<i class="fas fa-arrow-up-right-from-square ps-2"></i>
        </a>
    </div>
</div>